import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import {ErrorDialogController} from './ErrorDialog.controller';
import Translate from '../../components/translate/Translate';
import classNames from 'classnames';

import './ErrorDialog.style.scss';
import {requireImage} from '../../utils/utils';

interface ErrorDialogProps {
    ctrl: ErrorDialogController;
}

interface ErrorDialogHeaderProps {
    ctrl: ErrorDialogController;
}

interface ErrorDialogContentProps {
    ctrl: ErrorDialogController;
}

interface ErrorDialogToolbarProps {
    ctrl: ErrorDialogController;
}

const ErrorDialogHeader = observer(({ctrl}: ErrorDialogHeaderProps): JSX.Element => {
    return (
        <div className='on-video-alert-header' dir={ctrl.dir}>
            <img src={requireImage('attention.png')} alt='Attention' />
        </div>
    );
});

const ErrorDialogContent = observer(({ctrl}: ErrorDialogContentProps): JSX.Element => {
    return (
        <div className='on-video-alert-message' dir={ctrl.dir}>
            <p>
                <Translate text={ctrl.message} />
            </p>
        </div>
    );
});

const ErrorDialogToolbar = observer(({ctrl}: ErrorDialogToolbarProps): JSX.Element => {
    if (!ctrl.showRetryButton) {
        return <React.Fragment />;
    }

    return (
        <div className='on-video-alert-footer' dir={ctrl.dir}>
            <button onClick={ctrl.retry}>
                <span>
                    <Translate text='ERROR_DIALOG.RETRY_DOWNLOAD' />
                </span>
            </button>
        </div>
    );
});

@observer
export class ErrorDialog extends TechseeBaseComponent<ErrorDialogProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        const modalClassName = classNames('on-video-alert', {
            'mobile-modal': ctrl.isMobile,
            'mini-modal-dialog': ctrl.isMiniDashboard
        });

        return (
            <GenericModal
                className={modalClassName}
                header={() => <ErrorDialogHeader ctrl={ctrl} />}
                content={() => <ErrorDialogContent ctrl={ctrl} />}
                toolbar={() => <ErrorDialogToolbar ctrl={ctrl} />}
                onHideHandler={ctrl.close}
                show={ctrl.isVisible}
            />
        );
    }
}
